import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "../../../routes";
import {
  ButtonSecondary,
  GelContentContainer,
  HeroBlock,
  Notice, Notices,
  Controls,
  Loading,
  FormErrorSummary, Role
} from "cw-styleguide-react";

import CourseGroupsCreateEditForm from "../components/CourseGroupsCreateEditForm";
import { OPERATION_EDIT, ROLE_STAFF } from "../../../constants";

class CourseGroupsEditView extends Component {

  render() {

    if (!this.props.loaded) {
      return <GelContentContainer>
        <FormErrorSummary errors={this.props.formErrors} />
        <Loading text={this.props.t('local:view.courseGroups.edit.messages.loading')} />
      </GelContentContainer>
    }

    return (
      <Fragment>

        <Helmet>
          <title>{this.props.t('local:view.courseGroups.edit.title')}</title>
        </Helmet>

        <BreadcrumbsItem to={route('courseGroupsManage') + '/' + route('courseGroupsEdit', { courseGroup: this.props.values.id })}>
          {this.props.t('view.courseGroups.edit.breadcrumb')}
        </BreadcrumbsItem>

        <GelContentContainer>
          <h1>{this.props.t('local:view.courseGroups.edit.title')}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>{this.props.t('local:view.courseGroups.edit.introduction')}</p>
        </HeroBlock>

        <GelContentContainer>
          {this.props.failedToLoad ?
            <Notice type={'warning-alert'}>{this.props.t('styleguide:messages.error204')}</Notice>
            :
            <Fragment>

              <Notices messages={this.props.messages} />
              <FormErrorSummary errors={this.props.formErrors} />

              <Controls>

                <ButtonSecondary url={route('courseGroupsManage') + this.props.query} title={this.props.t('local:view.courseGroups.manage.controls.cancel')}>{this.props.t('local:view.courseGroups.manage.controls.cancel')}</ButtonSecondary>
                <ButtonSecondary onClick={() => { this.props.saveCourseGroup() }} title={this.props.t('local:view.courseGroups.manage.controls.save')}>{this.props.t('local:view.courseGroups.manage.controls.save')}</ButtonSecondary>

                <Role roles={[ROLE_STAFF]}>
                  <ButtonSecondary onClick={() => { this.props.toggleModal(['delete'], true) }} title={this.props.t('local:view.courseGroups.create.controls.delete')}>{this.props.t('local:view.courseGroups.create.controls.delete')}</ButtonSecondary>
                </Role>


                <ButtonSecondary disabled={!this.props.values.courseCount > 0} onClick={() => { this.props.toggleModal(['archive'], true) }} title={this.props.t('local:view.courseGroups.create.controls.archive')}>{this.props.t('local:view.courseGroups.create.controls.archive')}</ButtonSecondary>

                <Role roles={[ROLE_STAFF]}>
                  <ButtonSecondary disabled={!this.props.values.courseCount > 0} onClick={() => {
                    this.props.navigate(route('courses') + '/' + route('coursesUpdateByGroup', { courseGroup: this.props.values.id }));
                  }} title={this.props.t('local:view.courses.manage.controls.massUpdate')}>{this.props.t('local:view.courses.manage.controls.massUpdate')}</ButtonSecondary>
                </Role>

              </Controls>
              <h2>{this.props.values.courseGroupName}</h2>
              <CourseGroupsCreateEditForm {...this.props} mode={OPERATION_EDIT} />
            </Fragment>
          }
        </GelContentContainer>
      </Fragment>
    )
  }
}

export default withTranslation('local')(CourseGroupsEditView);
